import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Topnavbar from "./Topnavbar";
import { useMsal } from "@azure/msal-react";
import { getToken } from '../auth/authConfig.js';
import { styled, useTheme, alpha } from "@mui/material/styles";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import {
  FaBell,
  FaChartBar,
  FaChartLine,
  FaCog,
  FaFileAlt,
  FaHome,
  FaQuestionCircle,
  FaRobot,
  FaSignInAlt,
  FaUserAlt,
} from "react-icons/fa";
import MuiDrawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { useLocation } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";

const drawerWidth = 300;


const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  // backgroundImage: `linear-gradient(rgba(0,0,160,0.5), rgba(47, 46, 53,0.9)),url(${bgimg})`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundPosition: "center",
  background: "black",
  color: "white",
  overflowX: "hidden",
  borderRight: "1px dotted rgba(86,88,105, 1) !important",
  "&& .Mui-selected": {
    outline: "0px",
    border: "0px",
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    appearance: "none",
    display: "flex",
    flexGrow: "1",
    justifyContent: "flex-start",
    alignItems: "center",
    textDecoration: "none",
    boxsizing: "border-box",
    textAlign: "left",
    transition: "background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    position: "relative",
    textTransform: "capitalize",
    color: "rgb(32, 101, 209);",
    borderRadius: "8px !important",
    backgroundcColor: "#1453A0",
    fontWeight: "700 !important",
  },
  "&& .logoutLayout": {
    // add any additional styles for logoutLayout class here
    left: "20px !important",
  },
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  backgroundColor: "black",
  color: "white",
  overflowX: "hidden",
  borderRight: "1px dotted rgba(86,88,105, 1) !important",
  padding: "0px",

  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 20px)`,
  },
  "&& .Mui-selected": {
    borderRadius: "8px !important",
  },
  "&& .logoutLayout": {
    // add any additional styles for logoutLayout class here
    left: "8px !important",
  },
});

const openbox = (theme) => ({
  left: "286px !important",
});

const closebox = (theme) => ({
  left: "72px !important",
});

const listTogglebox = (theme) => ({
  padding: "0 !important",
  paddingTop: "2rem !important",
  padding: "1rem .5rem 0rem !important",
  borderRadius: "20px",
});

const listTogglebox1 = (theme) => ({
  display: "none !important",
});


const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "noWrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
    "& .navButtonToggle": openbox(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
    "& .navButtonToggle": closebox(theme),
    "& .listToggle": listTogglebox(theme),
    "& .listToggle1": listTogglebox1(theme),
  }),
}));

const SideNavbar = ({ LoggedinUser }) => {
  const [open, setOpen] = useState(false);
  const [userRole, setUserRole] = useState(localStorage.getItem("GroupName") || '');
  const [openDialog, setopenDialog] = useState(false);

  const MenuItems = [
    {
      menu: "Overview",
      route: "/",
      icon: <FaHome className="colorCss" fontSize={24} />,
    },
   
    {
      menu: "Details",
      route: "/all-details",
      icon: <FaChartBar className="colorCss" fontSize={24} />,
    },
    // {
    //   menu: "Summary",
    //   route: "/Summary",
    //   icon: <FaChartLine className="colorCss" fontSize={24} />,
    // },
    {
      menu: "Notifications",
      route: "/notifications",
      icon: <FaBell className="colorCss" fontSize={24} />,
    },
    {
      menu: "Settings",
      route: "/settings",
      icon: <FaCog className="colorCss" fontSize={24} />,
    }

  ];

  useEffect(() => {
    const getTokenKeys = localStorage.getItem('msal.token.keys.f6e22498-feb4-49b3-bfcd-d6934ecec039')
    const jsonCon = getTokenKeys && JSON.parse(getTokenKeys)
    const getIDTokenKey = jsonCon && jsonCon?.idToken[0]
    const getIdToken = getIDTokenKey && localStorage.getItem(`${getIDTokenKey}`)
    const jsonIDtoken = getIdToken && JSON.parse(getIdToken)
    const secret = jsonIDtoken && jsonIDtoken?.secret
    localStorage.setItem(
      "access-token-storage",
      JSON.stringify({ accessToken: secret })
    );

  }, [])

  const { pathname } = useLocation();
  const logout = async () => {
    // Will redirect to Okta to end the session then redirect back to the configured `postLogoutRedirectUri`
    localStorage.clear();
    window.location.href = `${process.env.REACT_APP_SSO_LOGOUT_REDIRECT_URL}`;
  };

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <Topnavbar open={open} Role={userRole} />

        <Drawer className="sidenavBarstyle" variant="permanent" open={open}>
          <IconButton
            className="navButtonToggle bgColorNew borderColorNew"
            onClick={() => {
              setOpen(!open);
            }}
          >
            {open === false ? (
              <ChevronRightIcon className="colorCss" />
            ) : (
              <ChevronLeftIcon className="colorCss" />
            )}
          </IconButton>
          {open && (
            <>
              <div style={{ position: "relative", marginTop: "0px" }}>
                <div
                  style={{
                    backgroundRepeat: "no-repeat",
                    paddingTop: "2rem",
                    marginTop: "0px",
                  }}
                >

                </div>

                {/* <input
                  type="file"
                  id="imageInput"
                  accept="image/*"
                  style={{ display: "none" }}
                  onChange={handleImageChange}
                /> */}


              </div>

            </>
          )}

          {!open && (
            <>
              <div
                style={{
                  position: "relative",
                  marginTop: "0px",
                }}
              >
                <div
                  style={{
                    marginTop: "0px",
                    paddingBottom: "1rem",
                  }}
                >

                </div>
              </div>
            </>
          )}

          <List
            className="listToggle"
            style={{
              padding: "1.3rem",
              display: "grid",
              gridGap: "1rem",
              paddingTop: "2rem",
            }}
          >

            <div className="test">


              {MenuItems.map((menuItem, index) => {


                return (
                   <a href={`${menuItem.route}`}>
                  <ListItem
                    key={index}
                    style={{ color: "white" }}
                    className="itemsmenulist colorCss"
                    selected={menuItem.route === pathname}
                    disablePadding
                    sx={{ display: "block" }}
                    title={menuItem.menu}
                  >
                    <ListItemButton
                      sx={{
                        minHeight: 53,
                        justifyContent: open ? "initial" : "center",
                        px: 2.5,
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : "auto",
                          justifyContent: "center",
                        }}
                        className="colorCss"
                      >
                        {menuItem.icon}
                      </ListItemIcon>
                      <ListItemText
                        className="listToggle1"
                        primary={menuItem.menu}
                        sx={{ opacity: open ? 1 : 0 }}
                      />
                    </ListItemButton>
                  </ListItem>
                   </a>
                );
              })}
            </div>
            <div
              className="logoutLayout"

            >


              <ListItem
                className="itemsmenulist itemsmenulist2  LogoutBTn"
                title="Logout"

                disablePadding
                sx={{ display: "block" }}
                onClick={() => {
                  setopenDialog(!openDialog);
                }}
              >
                <ListItemButton
                  sx={{
                    minHeight: 53,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <FaSignInAlt className="colorCss" fontSize={20} />
                  </ListItemIcon>
                  <ListItemText
                    className="listToggle1 colorCss"
                    primary="Logout"
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                </ListItemButton>
              </ListItem>


            </div>
          </List>
        </Drawer>

        <Dialog
          open={openDialog}
          onClose={() => {
            setopenDialog(!openDialog);
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          id="logoutPopup"
        >
          <DialogTitle id="alert-dialog-title">
            {"Are you sure you want to logout ?"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Please confirm your decision.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setopenDialog(!openDialog);
              }}
            >
              No
            </Button>
            <Button onClick={logout}>Yes</Button>
          </DialogActions>
        </Dialog>
      </Box>
    </>
  );
};

export default SideNavbar;
